import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const RolesRoutes: RouteObject[] = [
  {
    path: ROUTES.ROLES.LIST,
    element: (
      <PrivateRoute>
        <Pages.Roles />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ROLES.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddRoles />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ROLES.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditRoles />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ROLES.VIEW(':id'),
    element: (
      <PrivateRoute>
        <Pages.ViewRoles />
      </PrivateRoute>
    ),
  },
]

export default RolesRoutes
